module.exports = __webpack_public_path__ + "static/media/img-feature-company-200@2x.b4d752cc.png";